export const logo = require('../assets/img/logo.png')
export const slider1 = require('../assets/img/slider/1.jpg')
export const slider2 = require('../assets/img/slider/2.jpg')
export const slider3 = require('../assets/img/slider/3.jpg')
export const bgIntroAbout = require('../assets/img/bg/bg-intro-about.png')
export const aboutImg = require('../assets/img/about-img.png')
export const skillImg = require('../assets/img/skill-img.jpg')
export const whyChoose = require('../assets/img/why-choose.jpg')
export const videoBg = require('../assets/img/bg/video-bg.jpg')
export const portfolio1 = require('../assets/img/portfolio/1.jpg')
export const portfolio2 = require('../assets/img/portfolio/2.jpg')
export const portfolio3 = require('../assets/img/portfolio/3.jpg')
export const portfolio4 = require('../assets/img/portfolio/4.jpg')
export const portfolio5 = require('../assets/img/portfolio/5.jpg')
export const portfolio6 = require('../assets/img/portfolio/6.jpg')
export const leftArrow = require('../assets/img/prev.gif')
export const rightArrow = require('../assets/img/next.gif')
export const team1 = require('../assets/img/team/1.jpg')
export const team2 = require('../assets/img/team/2.jpg')
export const team3 = require('../assets/img/team/3.jpg')
export const team4 = require('../assets/img/team/4.jpg')
export const testimonial1 = require('../assets/img/testimonial/1.jpg')
export const testimonial2 = require('../assets/img/testimonial/2.jpg')
export const testimonial3 = require('../assets/img/testimonial/3.jpg')
export const testimonial4 = require('../assets/img/testimonial/4.jpg')
export const blog1 = require('../assets/img/blog/1.jpg')
export const blog2 = require('../assets/img/blog/2.jpg')
export const blog3 = require('../assets/img/blog/3.jpg')
export const contactBg = require('../assets/img/bg/contact-bg.jpg')
export const partner1 = require('../assets/img/partner/1.png')
export const partner2 = require('../assets/img/partner/2.png')
export const partner3 = require('../assets/img/partner/3.png')
export const partner4 = require('../assets/img/partner/4.png')
export const partner5 = require('../assets/img/partner/5.png')
export const partner6 = require('../assets/img/partner/6.png')
export const sectionBg = require('../assets/img/bg/section_bg.jpg')
// export const chooseImg = require('../assets/img/choose.jpg')
// export const package1 = require('../assets/img/special-package/1.jpg')
// export const package2 = require('../assets/img/special-package/2.jpg')
// export const package3 = require('../assets/img/special-package/3.jpg')
// export const package4 = require('../assets/img/special-package/4.jpg')
// export const package5 = require('../assets/img/special-package/5.jpg')
// export const package6 = require('../assets/img/special-package/6.jpg')
// export const gallery1 = require('../assets/img/gallery/1.jpg')
// export const gallery2 = require('../assets/img/gallery/2.jpg')
// export const gallery3 = require('../assets/img/gallery/3.jpg')
// export const gallery4 = require('../assets/img/gallery/4.jpg')
// export const gallery5 = require('../assets/img/gallery/5.jpg')
// export const gallery6 = require('../assets/img/gallery/6.jpg')

// export const packages1 = require('../assets/img/package/1.jpg')
// export const packages2 = require('../assets/img/package/2.jpg')
// export const packages3 = require('../assets/img/package/3.jpg')
// export const clientBg = require('../assets/img/bg/client-bg.png')

// export const review1 = require('../assets/img/review/1.png')
// export const review2 = require('../assets/img/review/2.png')
// export const review3 = require('../assets/img/review/3.png')

// export const footLogo = require('../assets/img/foot-logo.png')
// export const bgSection1 = require('../assets/img/bg/section-bg.jpg')
// export const widget1 = require('../assets/img/blog/widget/1.jpg')
// export const widget2 = require('../assets/img/blog/widget/2.jpg')
// export const widget3 = require('../assets/img/blog/widget/3.jpg')
// export const widget4 = require('../assets/img/blog/widget/4.jpg')
// export const widget5 = require('../assets/img/blog/widget/5.jpg')
// export const widget6 = require('../assets/img/blog/widget/6.jpg')
// export const comment1 = require('../assets/img/comment/1.png')
// export const comment2 = require('../assets/img/comment/2.png')
// export const comment3 = require('../assets/img/comment/3.png')